import { db } from "../firebase";

import {
  doc,
  getDoc,
  runTransaction,
} from "../../Common/utils/firebaseFunctions";

export const updateWithTransaction = async (
  docId: string,
  updateData: Partial<any>,
  collectionName: string
) => {
  // this will prevent concurrent changes

  await runTransaction(db, async (transaction) => {
    const dataDoc = await doc(db, collectionName, docId);
    const transactionData = await transaction.get(dataDoc); // transaction will monitor for any changes

    if (!transactionData.exists()) {
      throw new Error("Data does not exist");
    }
    // if transaction data reference changed before update, it will run again before updating to make sure up to date data
    transaction.update(transactionData.ref, updateData);
  });
};
